import { ref } from "vue";

let confirmDialogsCounter = 0;
export const confirmDialogs = ref([]);

export default {
  install(app) {
    app.config.globalProperties.$dialogConfirm = (params) => {
      let resolveHandler;
      let rejectHandler;

      const promise = new Promise((resolve, reject) => {
        resolveHandler = resolve;
        rejectHandler = reject;
      });

      confirmDialogs.value.push({
        id: confirmDialogsCounter,
        promise,
        resolveHandler,
        rejectHandler,
        params,
      });
      confirmDialogsCounter++;

      return promise;
    };
  },
};
